<template>
  <div>
    <section class="bg-green" style="padding: 40px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center div-header2">
            <h1 class="text-white">Babuyang Walang Amoy</h1>
            <div class="subheader-white">
              <p class="font18">With Feedpro, you can enjoy running an odor-free and easy-to-manage piggery that allows for stress-free pigs that are less prone to sickness and diseases.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="row-panel2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 div-header3 text-center">
            <h2>Life is Easier with Feedpro</h2>
            <div class="subheader mobile-space">
              <p>
                Feedpro's Babuyang Walang Amoy technology is the ideal backyard or semi-commercial farms set-up because of its convenience and friendliness to the community and environment. Join the thousands of farmers making the switch to
                Feedpro and natural farming.
              </p>
            </div>
          </div>
        </div>
        <div class="row row-panel" style="margin-top: 40px;">
          <div class="col-lg-5 col-md-12 col-sm-12 div-image margtop-25">
            <img :src="`${state.root_url}/images/bwa-1.png`" class="img-bwa" />
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader feedpro-flex" style="height: auto; padding-left: 40px;">
            <div>
              <h2 class="font38">Benefits Beyond the Profits</h2>
              <p>
                Feedpro and Babuyang Walang Amoy has a multitude of benefits: it solves bad odor and health risks in piggeries. It is easier to manage, cleaner, and more cost effective. It contributes to global health and food security by
                reducing our reliance to antibiotics. It is environment and community-friendly. And it mimics the pigs’ natural habitat thus promotes humane animal treatment.
              </p>
            </div>
          </div>
        </div>
        <div class="row row-panel">
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader div-right reverse-div2">
            <div>
              <h2 class="font38">No Rice Hull, No Problem</h2>
              <p>
                Over the years, our customers have proven that rice hull or substrate beddings, while ideal, are not necessary to produce an odor-free piggery. Because of rice hull shortage in some areas, customers have stayed with cemented
                floorings and stilled reaped the same benefits from using Feedpro.
              </p>
            </div>
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12 div-image reverse-image2">
            <img :src="`${state.root_url}/images/bwa-2.png`" class="img-bwa" />
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12 div-image reverse-image">
            <img :src="`${state.root_url}/images/bwa-2.png`" class="img-bwa" />
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader div-right div-headertop6 reverse-div">
            <h2 class="font38">No Rice Hull, No Problem</h2>
            <p>
              Over the years, our customers have proven that rice hull or substrate beddings, while ideal, are not necessary to produce an odor-free piggery. Because of rice hull shortage in some areas, customers have stayed with cemented
              floorings and stilled reaped the same benefits from using Feedpro.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 col-md-12 col-sm-12 div-image">
            <img :src="`${state.root_url}/images/bwa-3.png`" class="img-bwa" />
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader feedpro-flex" style="height: auto; padding-left: 40px;">
            <div>
              <h2 class="font38">Easily Switch from Other Brands</h2>
              <p>
                If you are shifting from other brands to Feedpro, there is no need to alter or change your current conventional piggery set-up. Just begin using Feedpro and practice correct management protocols to significantly reduce or
                eliminate foul odor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-green row-panel2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 div-header2 div-switching">
            <h2 class="font48">How to Set Up Your Babuyang Walang Amoy</h2>
            <div class="text-white">
              <p>
                The 3D model below is the recommended standard for setting up your Babuyang Walang Amoy. One side uses a rice hull bedding set-up while the other uses a cemented flooring set-up. These are recommendations only and your piggery
                will depend on several factors including the location, available capital and resources in the area, and so on. We highly encourage you to contact a technical sales person prior to any construction.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 text-center div-headertop9">
            <div class="sketchfab-embed-wrapper div-youtube">
              <iframe
                width="100%"
                height="440"
                src="https://sketchfab.com/models/1e61fef13c5c4c7997e963030a56ae3a/embed?autostart=1"
                frameborder="0"
                allow="autoplay; fullscreen; vr"
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-video div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 div-subheader feedpro-flex" style="height: auto;">
            <div>
              <h2>FeedproTV Feature</h2>
              <h4 class="roboto400">Babuyang Walang Amoy</h4>
              <p>Watch this video for complete visual guide to setting up your Babuyang Walang Amoy the Feedpro way. The video also features natural piggeries from customers all around the country.</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 div-youtube">
            <iframe 
              width="100%" 
              height="280" 
              src="https://www.youtube.com/embed/1YU-12zp-Do" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen="">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { reactive } from 'vue';

export default {
  setup() {
    const state = reactive({
      root_url: process.env.VUE_APP_ENDPOINT
    });

    return {
      state
    }
  }
}
</script>